import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './Modal.module.scss';

export type ModalProps = {
  variant?: 'paylink' | 'creditCard' | 'onBoarding';
  size?: 'none' | 'sm' | 'md' | 'lg';
  isVisible?: boolean;
  isDark?: boolean;
  enableBgClick?: boolean;
  onBgClick?: () => void;
  children: React.ReactNode;
  zIndex?: number;
};

type FC = FunctionComponent<ModalProps>;

const Modal: FC = ({
  variant,
  isVisible = true,
  isDark,
  enableBgClick = true,
  children,
  onBgClick,
  zIndex,
  size = 'none',
}: ModalProps) => {
  const [displayClass, setDisplayClass] = useState('hidden');

  useEffect(() => {
    setDisplayClass(isVisible ? 'visible' : 'hidden');
  }, [isVisible]);

  const handleBackgroundClick = () => {
    if (enableBgClick) {
      setDisplayClass('hidden');
      onBgClick?.();
    }
  };

  return (
    <div
      className={[styles.container, styles[displayClass], styles[getBGClass()], styles[variant || '']].join(' ')}
      style={{ zIndex }}
      onClick={handleBackgroundClick}
      aria-hidden={!isVisible}
      role="dialog"
      // data-state={isVisible ? 'open' : 'closed'}
    >
      <div
        className={[styles.content, styles[size]].join(' ')}
        onClick={(e) => e.stopPropagation()}
        aria-hidden={!isVisible}
      >
        {children ? React.Children.only(children) : <p>There is not much here...</p>}
      </div>
    </div>
  );

  function getBGClass() {
    return isDark ? 'dark' : '';
  }
};

export default Modal;
